/**
 * 获取token
 */
export function getToken(){
    const token = localStorage.getItem("cmm_token");
    if(token == null){
        return null;
    }else{
        return token;
    }
}
/**
 * 
 * @param {设置token} token 
 */
export function setToken(token){
    if (token) {
        localStorage.setItem("cmm_token", token);
    } else {
        localStorage.removeItem("cmm_token");
    }
}
/**
 * 是否登录
 * @param {*} token 
 */
export function setIsLoggedIn(isLoggedIn){
    localStorage.setItem("isLoggedIn",isLoggedIn);
}

export function getIsLoggedIn(){
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if(isLoggedIn == null){
        return false;
    }else{
        return isLoggedIn === 'true';  // 转为布尔值
    }
}
/**
 * 获取token
 */
export function getLoginUserInfo(){
    const user = localStorage.getItem("cmm_login_user");
    if(user == null){
        return null;
    }else{
        return JSON.parse(user);
    }
}
/**
 * 
 * @param {设置user} user 
 */
export function setLoginUserInfo(user){
    localStorage.setItem("cmm_login_user",JSON.stringify(user));
}